import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import "../style/adminreport.css";

function AdminReports() {
  const navigate = useNavigate();
  const [reportsData, setReportsData] = useState([]);
  const [search, setSearch] = useState("");
  const [filterWing, setFilterWing] = useState("");
  const [filterFlat, setFilterFlat] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);
  const rowsPerPage = 10;

  useEffect(() => {
    setLoading(true);
    axios.get("https://api.lr.payplatter.in/api/meter-readings/all-page")
      .then(response => {
        console.log("API Response:", response.data);
        const formattedData = response.data.map(item => ({
          id: item.id,
          wing: item.wingName || "N/A",
          flatNo: item.flatNo || "N/A",
          prevReading: item.previousReading || 0,
          currReading: item.currentReading || 0,
          difference: item.difference || 0,
          // image: item.fileData ? `data:image/jpeg;base64,${item.fileData}` : null,
          date: item.date ? new Date(item.date).toISOString().split('T')[0] : "N/A",
        }));
        console.log("Formatted Data:", formattedData);
        setReportsData(formattedData);
      })
      .catch(error => console.error("Error fetching data:", error))
      .finally(() => setLoading(false));
  }, []);


  function getImageById(id) {
    setModalImage(null);
    axios.get("https://api.lr.payplatter.in/api/meter-readings/getImageById/"+id)
      .then(response => {

        // console.log(response.data.image);
        setModalImage(response.data.image);
      })
      .catch(error => console.error("Error fetching data:", error))
      .finally(() => setLoading(false));
  }
  const formatDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(date).toLocaleDateString('en-GB', options).replace(',', '');
  };

  const filteredData = reportsData
    .filter((report) => report.wing.includes(filterWing))
    .filter((report) => report.flatNo.includes(filterFlat))
    .filter((report) =>
      (!startDate || new Date(report.date) >= new Date(startDate)) &&
      (!endDate || new Date(report.date) <= new Date(endDate))
    )
    .filter((report) =>
      report.wing.toLowerCase().includes(search.toLowerCase()) ||
      report.flatNo.includes(search)
    );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData.map(report => ({
      Building: report.wing,
      "Flat No": report.flatNo,
      // "Previous Reading": report.prevReading.toFixed(2),
      "Current Reading": report.currReading.toFixed(2),
      // Difference: (report.currReading - report.prevReading).toFixed(2),
      Date: formatDate(report.date),
    })));
  
    worksheet["!protect"] = {
      password: "admin@123",
      selectLockedCells: true,
      selectUnlockedCells: true,
      formatCells: false,
      formatColumns: false,
      formatRows: false,
      insertColumns: false,
      insertRows: false,
      insertHyperlinks: false,
      deleteColumns: false,
      deleteRows: false,
      sort: false,
      autoFilter: false,
      pivotTables: false,
      objects: false,
      scenarios: false,
    };
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reports");
  
    // Write the file with sheet protection
    XLSX.writeFile(workbook, "reports.xlsx");
  };
  
  return (
    <div className="reports-wrapper">
      <nav className="reports-navbar">
        <span className="reports-title">Water Billing Reports</span>
      </nav>
      {/* <div className="reports-search-container">
        <input
          type="text"
          placeholder="Search by Wing, Flat No, or Date..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="reports-search"
        />
      </div> */}

      <div className="reports-filter-container">
      <input
          type="text"
          placeholder="Search by Wing, Flat No, or Date..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="reports-search"
        />
        <input type="text" placeholder="Filter by Wing..." value={filterWing} onChange={(e) => setFilterWing(e.target.value)} className="reports-filter" />
        <input type="text" placeholder="Filter by Flat No..." value={filterFlat} onChange={(e) => setFilterFlat(e.target.value)} className="reports-filter" />
      </div>

      <div className="reports-filter-containerr">
        <input
          type="text"
          value={startDate ? new Date(startDate).toLocaleDateString() : ""}
          onFocus={(e) => (e.target.type = "date")}
          onBlur={(e) => (e.target.type = "text")}
          onChange={(e) => setStartDate(e.target.value)}
          placeholder="Select Start Date"
          className="reports-filter"
        />

        <input
          type="text"
          value={endDate ? new Date(endDate).toLocaleDateString() : ""}
          onFocus={(e) => (e.target.type = "date")}
          onBlur={(e) => (e.target.type = "text")}
          onChange={(e) => setEndDate(e.target.value)}
          placeholder="Select End Date"
          className="reports-filter"
        />

        <button className="export-btn" onClick={exportToExcel}>
          <i className="fas fa-file-excel"></i> Export to Excel
        </button>
      </div>

      <div className="reports-table-wrapper">
        <table className="reports-table">
          <thead>
            <tr>
              <th>Building</th>
              <th>Flat No</th>
              {/* <th>Previous Reading</th> */}
              <th>Current Reading</th>
              {/* <th>Difference</th> */}
              <th>Uploaded Image</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="7" className="table-loader">Loading...</td></tr>
            ) : paginatedData.length === 0 ? (
              <tr><td colSpan="7">No reports available</td></tr>
            ) : (
              paginatedData.map(report => (
                <tr key={report.id}>
                  <td>{report.wing}</td>
                  <td>{report.flatNo}</td>
                  {/* <td>{report.prevReading.toFixed(2)}</td> */}
                  <td>{report.currReading.toFixed(2)}</td>
                  {/* <td>{report.difference.toFixed(2)}</td> */}
                  <td>
                    {<button onClick={()=>{getImageById(report.id)}}>View Image</button>}
                  </td>
                  <td>{formatDate(report.date)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {modalImage && (
        <div className="modal" onClick={() => setModalImage(null)}>
          <img src={`${modalImage}`} alt="Meter" className="modal-content" />
        </div>
      )}
      <div className="pagination">
        <button disabled = {
          currentPage === 1
        }
        onClick={() => setCurrentPage(currentPage-1)}>prev</button>

        <span>page{currentPage} of {totalPages}</span>
        <button disabled ={
          currentPage === totalPages}
        onClick={() => setCurrentPage(currentPage+1)}>Next</button>
      </div>
      <div className="footer">
        <p>powered by @Dexpert Systems</p>
      </div>
    </div>
  );
}

export default AdminReports;